module.exports = __webpack_public_path__ + "static/media/VisbyCF-Bold.958b0977.woff";